<template>
  <div>
    <div class="d-flex align-items-center justify-content-between mb-3">
      <div class="d-flex align-items-center">
        <h2 class="mr-3">Update Organisasi</h2>
      </div>
    </div>
    <a-card>
      <a-row class="mt-4" :gutter="[32, 32]">
        <a-col :span="24" class="d-flex justify-content-between align-items-center">
          <a-button @click="$router.back()"> <LeftOutlined />Back </a-button>
        </a-col>
        <a-col :span="24">
          <div>
            <h1 class="text-title">Informasi Organisasi</h1>
          </div>
          <div>
            <a-row :gutter="[24, 12]">
              <a-col :xs="{ span: 24 }" :sm="{ span: 8 }">
                <p class="text-label">INISIAL (4 HURUF)</p>
                <a-input
                  placeholder="Masukkan Inisial Organisasi"
                  v-model:value="payload.organizationSign"
                ></a-input>
              </a-col>
              <a-col :xs="{ span: 24 }" :sm="{ span: 8 }">
                <p class="text-label">Nama</p>
                <a-input
                  placeholder="Masukkan Nama Organisasi"
                  v-model:value="payload.name"
                ></a-input>
              </a-col>
              <a-col :xs="{ span: 24 }" :sm="{ span: 8 }">
                <p class="text-label">Email</p>
                <a-input
                  placeholder="Masukkan Email Organisasi"
                  v-model:value="payload.email"
                ></a-input>
              </a-col>
              <a-col :xs="{ span: 24 }" :sm="{ span: 8 }">
                <p class="text-label">Nomor Handphone</p>
                <a-input
                  placeholder="Masukkan Nomor Handphone"
                  v-model:value="payload.mobileNumber"
                ></a-input>
              </a-col>
              <a-col :xs="{ span: 24 }" :sm="{ span: 8 }">
                <p class="text-label">Nomor Kantor</p>
                <a-input
                  placeholder="Masukkan Nomor Kantor"
                  v-model:value="payload.officeNumber"
                ></a-input>
              </a-col>
              <a-col :xs="{ span: 24 }" :sm="{ span: 8 }">
                <p class="text-label">Penanggung Jawab</p>
                <a-input
                  placeholder="Masukkan Nama Penanggung Jawab"
                  v-model:value="payload.PIC"
                ></a-input>
              </a-col>
              <a-col :xs="{ span: 24 }" :sm="{ span: 8 }">
                <p class="text-label">Tipe</p>
                <a-select
                  v-model:value="payload.type"
                  placeholder="Pilih Tipe"
                  style="width: 100%;"
                >
                  <a-select-option value="National">National</a-select-option>
                  <a-select-option value="Province">Province</a-select-option>
                </a-select>
              </a-col>

              <a-col :xs="{ span: 24 }" :sm="{ span: 3 }">
                <p class="text-label">Logo Organisasi</p>
                <a-upload
                  v-model:file-list="fileList"
                  name="logo"
                  list-type="picture-card"
                  class="avatar-uploader"
                  :show-upload-list="{ showPreviewIcon: false }"
                  :before-upload="beforeUpload"
                  @remove="handleRemove"
                >
                  <div v-if="fileList.length < 1">
                    <plus-outlined></plus-outlined>
                    <div class="ant-upload-text">Ganti Logo</div>
                  </div>
                </a-upload>
              </a-col>

              <a-col :xs="{ span: 24 }" :sm="{ span: 24 }">
                <div class="w-100">
                  <p class="text-label">Alamat</p>
                  <a-textarea
                    placeholder="Masukkan Alamat Organisasi..."
                    allow-clear
                    v-model:value="payload.address"
                  ></a-textarea>
                  <a-input-search
                    placeholder="Cari alamat di peta..."
                    enter-button="Cari"
                    @search="searchAddressOnMap"
                    class="mt-2"
                  />
                  <div
                    id="mapContainer"
                    style="height: 345px; width: 100%; margin-top: 10px; border-radius: 8px; overflow: hidden;z-index: 0;"
                  ></div>
                </div>
              </a-col>
            </a-row>
          </div>
        </a-col>
        <a-col :span="24">
          <a-row :gutter="[24, 12]">
            <a-col :span="18"></a-col>
            <a-col :span="6" class="d-flex justify-content-end align-items-center" style="gap:15px">
              <a-button @click="fetchData()">Reset</a-button>
              <a-button @click="submitPayload()" type="primary">Update</a-button>
            </a-col>
          </a-row>
        </a-col>
      </a-row>
    </a-card>
  </div>
</template>

<script>
import { onMounted, ref } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { LeftOutlined, PlusOutlined } from '@ant-design/icons-vue'
import { notification, message } from 'ant-design-vue'
import { getOrganizationsById, putOrganizations } from '../../services/axios/modc/organization'
import 'leaflet/dist/leaflet.css'
import L from 'leaflet'
import { baseURL } from '../../services/axios'

delete L.Icon.Default.prototype._getIconUrl
L.Icon.Default.mergeOptions({
  iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
  iconUrl: require('leaflet/dist/images/marker-icon.png'),
  shadowUrl: require('leaflet/dist/images/marker-shadow.png'),
})

export default {
  components: { LeftOutlined, PlusOutlined },
  setup() {
    const route = useRoute()
    const router = useRouter()
    const payload = ref({})

    // State untuk file upload
    const fileList = ref([])
    const logoFile = ref(null)

    let map = null
    let marker = null

    const fetchData = async () => {
      try {
        const { organization } = await getOrganizationsById(route.params.id)
        payload.value = organization[0]

        // Jika ada logo, tampilkan sebagai preview
        if (payload.value.logo) {
          fileList.value = [
            {
              uid: '-1',
              name: 'logo.png',
              status: 'done',
              url: `${baseURL}${payload.value.logo}`, // URL lengkap ke gambar logo
            },
          ]
        } else {
          fileList.value = []
        }

        // Update peta setelah data terisi
        updateMapAndMarker()
      } catch (error) {
        notification.error({ message: 'Gagal', description: 'Gagal memuat data organisasi.' })
      }
    }

    const updateMapAndMarker = () => {
      if (map) {
        if (payload.value.latitude && payload.value.longitude) {
          const coords = [payload.value.latitude, payload.value.longitude]
          setMarker(coords[0], coords[1])
          map.setView(coords, 16)
        } else {
          map.setView([-6.2088, 106.8456], 13)
        }
      }
    }

    // --- (Fungsi peta lainnya tetap sama) ---
    const onMapClick = async e => {
      const { lat, lng } = e.latlng // Dapatkan latitude dan longitude dari event klik
      payload.value.latitude = lat
      payload.value.longitude = lng

      setMarker(lat, lng) // Tempatkan atau pindahkan marker ke lokasi klik

      // Lakukan Reverse Geocoding menggunakan OpenStreetMap Nominatim API
      try {
        const response = await fetch(
          `https://nominatim.openstreetmap.org/reverse?format=jsonv2&lat=${lat}&lon=${lng}`,
        )
        const data = await response.json()
        if (data && data.display_name) {
          payload.value.address = data.display_name // Set alamat lengkap ke payload
        } else {
          payload.value.address = `Koordinat: ${lat}, ${lng}` // Fallback jika alamat tidak ditemukan
        }
      } catch (error) {
        console.error('Error during reverse geocoding:', error)
        notification.error({
          message: 'Error Geocoding',
          description: 'Gagal mendapatkan alamat dari koordinat.',
        })
        payload.value.address = `Koordinat: ${lat}, ${lng} (Tidak dapat menemukan alamat)`
      }
    }

    // Fungsi untuk menempatkan atau memperbarui marker di peta
    const setMarker = (lat, lng) => {
      if (marker) {
        marker.setLatLng([lat, lng]) // Pindahkan marker yang sudah ada
      } else {
        marker = L.marker([lat, lng]).addTo(map) // Buat marker baru
      }
    }

    // Fungsi untuk mencari alamat di peta (Forward Geocoding)
    const searchAddressOnMap = async address => {
      if (!address) {
        notification.warn({
          message: 'Peringatan',
          description: 'Mohon masukkan alamat untuk mencari.',
        })
        return
      }

      // Lakukan Forward Geocoding menggunakan OpenStreetMap Nominatim API
      try {
        const response = await fetch(
          `https://nominatim.openstreetmap.org/search?format=json&q=${encodeURIComponent(address)}`,
        )
        const data = await response.json()

        if (data && data.length > 0) {
          const { lat, lon, display_name } = data[0] // Ambil hasil pertama
          payload.value.latitude = parseFloat(lat)
          payload.value.longitude = parseFloat(lon)
          payload.value.address = display_name

          setMarker(parseFloat(lat), parseFloat(lon)) // Tempatkan marker di lokasi yang ditemukan
          map.setView([parseFloat(lat), parseFloat(lon)], 16) // Fokus ke lokasi yang ditemukan dengan zoom lebih dekat

          notification.success({
            message: 'Alamat Ditemukan',
            description: `Menampilkan lokasi untuk: ${display_name}`,
          })
        } else {
          notification.error({
            message: 'Alamat Tidak Ditemukan',
            description: 'Tidak dapat menemukan lokasi untuk alamat yang diberikan.',
          })
        }
      } catch (error) {
        console.error('Error during forward geocoding:', error)
        notification.error({
          message: 'Error Pencarian Alamat',
          description: 'Terjadi kesalahan saat mencari alamat.',
        })
      }
    }

    // Fungsi untuk mereset payload dan tampilan peta
    const clearPayload = () => {
      payload.value = {
        organizationSign: '',
        name: '',
        email: '',
        mobileNumber: '',
        officeNumber: '',
        PIC: '',
        address: '',
        latitude: null,
        longitude: null,
      }
      // Hapus marker dari peta jika ada
      if (marker) {
        map.removeLayer(marker)
        marker = null
      }
      // Reset tampilan peta ke posisi default (contoh: Jakarta)
      map.setView([-6.2088, 106.8456], 13)
    }

    // Fungsi untuk upload file
    const handleRemove = () => {
      fileList.value = []
      logoFile.value = null
      // Jika menghapus logo, kita tandai untuk dihapus di backend (opsional)
      // atau biarkan kosong agar tidak diubah saat update.
      payload.value.logo = null
    }

    const beforeUpload = file => {
      const isImage = file.type.startsWith('image/')
      if (!isImage) {
        message.error('Anda hanya bisa meng-upload file gambar!')
        return false
      }
      const isLt2M = file.size / 1024 / 1024 < 2
      if (!isLt2M) {
        message.error('Gambar harus lebih kecil dari 2MB!')
        return false
      }
      logoFile.value = file
      // Menampilkan preview dari file lokal yang baru dipilih
      fileList.value = [{ ...file, url: URL.createObjectURL(file) }]
      return false // Mencegah upload otomatis
    }

    const submitPayload = async () => {
      const formData = new FormData()

      // Tambahkan semua data dari payload ke formData
      for (const key in payload.value) {
        if (payload.value[key] !== null && payload.value[key] !== undefined) {
          formData.append(key, payload.value[key])
        }
      }

      // Jika ada file BARU yang dipilih, tambahkan ke formData
      if (logoFile.value) {
        formData.append('logo', logoFile.value)
      }

      try {
        const data = await putOrganizations(formData, route.params.id)
        if (data) {
          notification.success({
            message: 'Berhasil Update',
            description: 'Data Organisasi telah diperbarui.',
          })
          router.push('/organizations')
        }
      } catch (error) {
        notification.error({
          message: 'Gagal Update',
          description: error.response?.data?.message || 'Terjadi kesalahan internal pada server.',
        })
      }
    }

    onMounted(() => {
      map = L.map('mapContainer').setView([-6.2088, 106.8456], 13)
      L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
        attribution:
          '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors',
      }).addTo(map)
      map.on('click', onMapClick)

      fetchData() // Ambil data setelah peta diinisialisasi
    })

    return {
      payload,
      submitPayload,
      searchAddressOnMap,
      fileList,
      beforeUpload,
      handleRemove,
      fetchData, // Ganti clearPayload dengan fetchData untuk tombol Reset
    }
  },
}
</script>

<style lang="scss">
@import '../styleViews.scss';

.text-title {
  font-size: 1.5rem; /* ... */
}
.text-subtitle {
  font-size: 1.3rem; /* ... */
}
.text-label {
  font-size: 1rem; /* ... */
}

.avatar-uploader > .ant-upload {
  width: 128px;
  height: 128px;
}
</style>
